<template>
	<div class="pay-dialog-paint">
		<el-dialog title width="500px" class="repair-dialog" :visible.sync="dialogHide" :before-close="handleClose" :close-on-press-escape="false"
			center :close-on-click-modal="false"
			:show-close='payWay == "yinlianStore" || payWay == "tonglianStore" ? false: true'>
			<div v-if="isScanTheCode">
				<template v-if="!isPayFail">
					<div class="fb fontSize20 mt20 mb40">订单处理中</div>
					<div v-loading="loading" style="height: 100px;"></div>
				</template>
				<template v-else>
          <div class="center"><img src="../../assets/images/new/pay-refuse.png" alt=""></div>
					<div class="fail-text fontSize20 ">支付失败</div>
					<div class="success-text fontSize20 pb20 mb20" style="font-weight: bold;">
						{{refuseMessage}}
					</div>
				</template>

			</div>
			<div class="ptb16" v-else>
				<!-- <el-image class="img" :src="successImg"></el-image> -->
        <div class="center"><img src="../../assets/images/new/pay-success.png" alt=""></div>
				<p class="money fail-text fontSize20">{{ hintName ? hintName : '支付成功' }}</p>
				<div class="success-text fontSize20 pb20" style="font-weight: bold;">
					<p v-if="amount || amount == 0">
						成功收款
						<span>{{ amount }}元</span>
					</p>
					<p v-else-if="meal == 'discount'" class="fontSize20 fb allColors">成功收款 <span>0元</span></p>
          <p v-if="balance || balance == '0'" class="color666 balance mt10">余额{{balance}}元</p>
					<!-- <p v-else class="success-text fontSize20">划卡成功</p> -->
					<p class="jishi cur mt10 f14" v-if="tradeNoPwdFlag && tradeNoPwdFlag.tradeNoPwdFlag == 'off'"
						@click="openClose">开通免密支付</p>
				</div>
			</div>
			<print ref="print" class="prints"></print>
			<span slot="footer" class="dialog-footer" v-if="!isScanTheCode">
				<el-button class="ml10" v-if="isPrint" @click="printReceipts">打印小票</el-button>
				<el-button class="btn small-btn" v-if="btnShow" @click="gotoOrderInfo">查看订单详情</el-button>
				<el-button class="btn small-btn" v-else @click="gotoOrderInfo">查看订单</el-button>
        <el-button class="btn small-btn" type="primary" v-if="source == 'topUp' && noPay" @click="handleClose">继续收银</el-button>
				<el-button class="btn small-btn" v-if="source != 'order'" @click="gotoProductFootBath">返回主页</el-button>
			</span>
			<span slot="footer" class="dialog-footer" v-if="isPayFail && isScanTheCode && !payWayWait">
				<el-button class="btn small-btn" @click="cancelOrder" v-if="source != 'topUp'">取消订单</el-button>
				<el-button class="btn small-btn" type="primary" @click="repay" v-if="source != 'topUp'">重新支付</el-button>
        <el-button class="btn small-btn" @click="handleClose" v-else>确定</el-button>
			</span>
			<span slot="footer" class="dialog-footer" v-if="isPayFail && payWayWait">
				<el-button class="btn small-btn" @click="handleClose">确定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import minxin from "../../assets/javascript/minxin.js";
	import print from "../components/print.vue";
	import {
		decrypt,
		encrypt
	} from "../../assets/javascript/untils";
	export default {
		mixins: [minxin],
		props: {
			hintName: {
				type: String,
				default: null
			},
      source: {
				type: String,
				default: null
			},
			amount: {
				type: Number,
				default: null
			},
			foot: {
				type: Boolean,
				default: false
			},
      noPay: {
				type: Boolean,
				default: true
			},
			meal: {
				type: String,
				default: null
			},
      balance: {
				type: String,
				default: null
			},
		},
		data() {
			return {
				form: {},
				orderId: "",
				dialogHide: false,
				headImg: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
				payWayList: [],
				parentForm: {},
				isPayWayHide: true,
				successImg: require("../../assets/images/money/success.png"),
				mainHeight: this.$store.getters.MainHeight,
				btnShow: false,
				tradeNoPwdFlag: "",
				isPrint: false,
				isScanTheCode: false,
				loading: false,
				isPayFail: false,
				timer: null,
				payWay: "",
				excuteCount: 0,
				refuseMessage: "",
				payWayWait: false
			};
		},
		created() {},
		components: {
			print
		},
		mounted() {
			this.init();
		},
		destroyed() {
			if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
			}
		},
		methods: {
      handleClose () {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.dialogHide = false;
        this.payWayWait = false;
        this.$emit("payFun", true);
			},
			init() {
				this.$on("set", function(id) {
					console.log("pay_init23");
					console.log(id);
					this.tradeNoPwdFlag = JSON.parse(localStorage.getItem("newTradeNoPwdFlag"))
					localStorage.removeItem("newTradeNoPwdFlag")
					console.log(id);
					if (!Array.isArray(id) && id.payWay) {
						this.orderId = id.orderId + '';
						this.payWay = id.payWay;
						this.isScanTheCode = true;
						this.queryFlag = id.queryFlag;
						this.openPayFullScreen();
						console.log("pay_init_openPayFullScreen222");
					} else {
						if (Array.isArray(id) && id.length > 1) {
							this.orderId = id[0];
							this.isPrint = false;
						} else {
							this.orderId = id + '';
							this.isPrint = true;
						}
					}

						console.log("pay_init_openPayFullScreen333");
					if (typeof id == "boolean" || Array.isArray(id)) {
						this.btnShow = false;
					} else {
						this.btnShow = true;
					}
					this.dialogHide = true;
					if (id.close) {
						this.isPayFail = true;
						this.refuseMessage = id.closeMessage;
						if (this.timer) {
              clearInterval(this.timer)
              this.timer = null;
						}
					}
				});
			},
			gotoOrderInfo() {
				if (this.btnShow) {
					if (this.foot) {
						if (Array.isArray(this.orderId) && this.orderId.length > 1) {
							return this.$router.push("/orderInfo")
						}
						this.$router.push({
							name: "/orderInfo",
							params: {
								id: this.orderId
							}
						});

					} else {
						this.dialogHide = false
						this.$emit("payFun", true);
					}
					this.orderId = "";
				} else {
					this.$router.push("/orderInfo");
					this.dialogHide = false;
					this.$emit("payFun", true);
					this.orderId = "";
				}
			},
			printReceipts() {
				this.$refs["print"].$emit("set", {
					orderId: this.orderId,
					isPrint: true
				});
			},
			openClose() {
				// 开通免密
				localStorage.setItem("tradeNoPwdFlag", JSON.stringify(this.tradeNoPwdFlag))
				this.$router.push("/member");
			},
			gotoProductFootBath() {
				this.dialogHide = false
				this.$emit("payFun", true);
			},
			openPayFullScreen(payRes) {
				console.log("openPayFullScreen2");
				console.log(this.payWay);
				this.isPayFail = false;
				this.loading = true;
				if (this.timer) {
          clearInterval(this.timer)
          this.timer = null;
				}
        //不轮询
				if (!this.queryFlag) {
					return;
				}

				this.$api.get(this.$url.orderInfo.getBSCPayStatus, {
					orderId: this.orderId,
					payWay: this.payWay,
				}).then(res => {
					console.log("getBSCPayStatus", res);
					if (res && res.payStatus) {
						if (res.payStatus != 'processing') {
							this.loading = false;
              clearInterval(this.timer);
              this.timer = null;
						}
						if (res.payStatus == 'finish') {
							this.isScanTheCode = false; // 成功处理
							return;
						} else if (res.payStatus == 'waitPay') {
							this.isScanTheCode = true;
							this.isPayFail = true;
							console.log("waitPay");
							console.log(res.payMsg);
							this.refuseMessage = res.payMsg;
              clearInterval(this.timer);
              this.timer = null;
							return;
						} else if (res.payStatus == 'cancel') {
								this.isScanTheCode = true;
								this.isPayFail = true;
								this.payWayWait = true;
								this.refuseMessage = res.payMsg;
								return;
							}
					} else {
						console.log("cancle", res);
						this.loading = false;
            clearInterval(this.timer);
            this.timer = null;
						this.dialogHide = false;
						this.$emit("payFun", false);
						return;
					}
				});

        this.excuteCount = 0;
				this.timer = setInterval(() => {
					if (!this.dialogHide) {
            clearInterval(this.timer);
            this.timer = null;
					}
					//每发一次询问请求
					this.$api.get(this.$url.orderInfo.getBSCPayStatus, {
						orderId: this.orderId,
						payWay: this.payWay,
					}).then(res => {

						this.excuteCount++;
						if (res && res.payStatus) {
							if (res.payStatus != 'processing') {
								this.loading = false;
                clearInterval(this.timer);
                this.timer = null;
							}
							if (res.payStatus == 'finish') {
								this.isScanTheCode = false;
								return;
							} else if (res.payStatus == 'waitPay' || this.excuteCount > 10) {
								this.isScanTheCode = true;
								this.isPayFail = true;
								this.refuseMessage = res.payMsg;
								if (this.excuteCount > 10) {
									this.refuseMessage = "支付超时，请重新支付";
								}
                clearInterval(this.timer);
                this.timer = null;
							} else if (res.payStatus == 'cancel') {
								this.isScanTheCode = true;
								this.isPayFail = true;
								this.payWayWait = true;
								this.refuseMessage = res.payMsg;
								console.log("cancel");
							}
						} else {
							this.loading = false;
              clearInterval(this.timer);
              this.timer = null;
							this.dialogHide = false;
							this.$emit("payFun", false);
						}
					})
				}, 5000)

			},
			cancelOrder() {
        if (this.payWay == 'cash') {
          return this.gotoProductFootBath();
        }
				let arr = encrypt(
					JSON.stringify({
						orderId: this.orderId
					})
				);
				this.$api.post(this.$url.orderInfo.cancel, arr).then(res => {
					if (res) {
						this.dialogHide = false;
						this.$emit("change", true);
            this.gotoProductFootBath();
						this.$notify({
							title: '成功',
							message: '操作成功',
							type: 'success'
						});
					}
				})
				
			},
			repay() {
				//重新支付
				this.dialogHide = false;
				console.log("repay");
				this.$emit("rePay");
			}
		}
	}
</script>
<style>
	.payway-success .el-button+.el-button {
		margin-left: 0;
	}
</style>
<style scoped lang="less">
	@import "../../assets/css/edit.less";

	/deep/ .el-loading-spinner .path {
		stroke-width: 6px;
		stroke: #3388FF !important;
	}
  .balance {
    font-size: 14px !important;
  }
	.pay-dialog-paint /deep/ .el-dialog {
		overflow: hidden;
	}

	/deep/ .el-dialog {
		margin-top: 0 !important;
		top: 20%;
		border-radius: 10px;
	}

	/deep/ .el-dialog__header {
		height: 50px;
		box-sizing: border-box;
		padding: 0;
		line-height: 50px;
		text-align: center;
		font-size: 0.18rem;
		border-bottom: none !important;

		.el-dialog__title {
			color: #fff;
		}

		.el-dialog__headerbtn {
			.el-dialog__close {
				color: #666;
				padding: 2px;
			}
		}
	}

	.pay-dialog-paint /deep/ .el-dialog__body {
		// height: auto;
		height: 100%;
		padding: 0;
		display: flex;
		justify-content: center;

		p {
			span {
				color: #FF4D4F;
			}
		}
    
		.money {
			font-size: 16px;
			font-weight: 500;
			text-align: center;
		}

		.success-text {
			width: 325px;
			margin-top: 16px;
			font-weight: 500;
			border-bottom: 1px solid #F5F5F5;
			text-align: center;

		}

		.fail-text {
			width: 325px;
			margin-top: 10px;
			font-weight: 500;
			text-align: center;

		}
	}

	/deep/ .el-dialog__footer {
		padding: 0 0 40px;
		text-align: center;

		.btn {
			font-size: 0.18rem;
		}

		.normal-btn {
			margin-right: 50px;
		}
	}
</style>
